import { mxCell } from 'mxgraph-js';
import HCLTreeMxGraphEncoder from './HCLTreeMxGraphEncoder';
import FaultTreeMxGraph, { FaultTreeMxGraphJSON } from '../HCLTreeMxGraph/FaultTreeMxGraph';
import FaultTreeVertex from '../HCLTreeNode/FaultTreeNode/FaultTreeVertex';
import ReferenceTypes from '../HCLTreeNode/HCLTreeVertexValue/ReferenceTypes';
import GateVertex from '../HCLTreeNode/FaultTreeNode/GateNode/GateVertex';
import GateVertexValue, { GateVertexValueJSON } from '../HCLTreeNode/FaultTreeNode/GateNode/GateVertexValue';
import Outcome from '../HCLTreeNode/HCLTreeVertexValue/Outcome';

import { BasicEventVertexValueJSON } from '../HCLTreeNode/FaultTreeNode/BasicEventNode/BasicEventVertexValue';
import { HouseEventVertexValueJSON } from '../HCLTreeNode/FaultTreeNode/HouseEventNode/HouseEventVertexValue';
import HCLTreeVertex from '../HCLTreeNode/HCLTreeVertex';
import FaultTreeMxGraphModel from "../HCLMxGraphModel/FaultTreeMxGraphModel";

class FaultTreeMxGraphEncoder extends HCLTreeMxGraphEncoder {
  /**
   * @param {FaultTreeMxGraph} graph
   */
  constructor(graph: FaultTreeMxGraph) {
    super(graph);
  }

  /**
   * traverse all the outgoing edges using DFS
   * @param {FaultTreeVertex} root
   * @param {FaultTreeMxGraphJSON} json - JSON to update
   */
  traverseSubtree(root: FaultTreeVertex, json: FaultTreeMxGraphJSON): void {
    // update GateVertexValue
    if (root instanceof GateVertex) {
      const value = root.getValue() as GateVertexValue;
      value.getFormula().setOutcomes(
        (root.getChildren() as FaultTreeVertex[]).map(child => Outcome.build(child.toReferenceJSON())),
      );
    }

    // @ts-ignore
    json[root.getReferenceType()][root.getKey()] = root.toJSON() as GateVertexValueJSON | BasicEventVertexValueJSON | HouseEventVertexValueJSON;
    (root.getChildren() as FaultTreeVertex[]).forEach((child) => {
      this.traverseSubtree(child, json);
    });
  }


  /**
   * @override
   * @return {FaultTreeMxGraphJSON}
   */
  encode(): FaultTreeMxGraphJSON {
    const json: FaultTreeMxGraphJSON = {
      [ReferenceTypes.BASIC_EVENTS]: {},
      [ReferenceTypes.HOUSE_EVENTS]: {},
      [ReferenceTypes.GATES]: {},
      components: {},
      top_node: {},
      name: this.getGraph().getTreeLabel().getName(),
      model_tree_id: this.getGraph().getModelTreeId(),
      label: this.getGraph().getTreeLabel().toJSON(),
    };

    const vertices = this.getGraph().getVertices() as FaultTreeVertex[];

    // @ts-ignore
    vertices.forEach(v => json[v.getReferenceType()][v.getKey()] = v.toJSON() as GateVertexValueJSON | BasicEventVertexValueJSON | HouseEventVertexValueJSON);

    const topNodes = (this.getGraph().getModel() as FaultTreeMxGraphModel).getTopNodes() as FaultTreeVertex[];

    if (topNodes.length === 0) return json;

    json.top_node = topNodes[0].toReferenceJSON();

    topNodes.forEach(topNode => this.traverseSubtree(topNode, json));

    return json;
  }
}

export default FaultTreeMxGraphEncoder;
